import React from 'react';

import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    buttons: {
        margin: `${theme.spacing(2)}px 0 0`,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    button: {
        marginRight: theme.spacing(2),
        '&:last-child': {
            margin: 0,
        },
    },
    progress: {
        marginLeft: 10,
    },

    buttonWithProgess: {
        minWidth: 100,
    },
    buttonWithLeft: {
        justifyContent: 'space-between',
    },
});

const ButtonsForm = ({ withLeft = false, classes, children }) => (
    <div
        className={classNames(classes.buttons, {
            [classes.buttonWithLeft]: withLeft,
        })}
    >
        {children}
    </div>
);

ButtonsForm.BackButton = withStyles(styles)(
    ({ classes, disabled, loading, onClick, label }) => (
        <Button
            onClick={onClick}
            className={classes.button}
            color="primary"
            disabled={loading || disabled}
        >
            {label || 'Cancel'}
        </Button>
    )
);

ButtonsForm.NextButton = withStyles(styles)(
    ({ classes, disabled, loading, onClick, label }) => (
        <Button
            onClick={onClick}
            className={classNames(classes.button, {
                [classes.buttonWithProgess]: loading,
            })}
            color="secondary"
            variant="contained"
            disabled={loading || disabled}
        >
            {label || 'Next'}
            {loading && (
                <CircularProgress size={12} className={classes.progress} />
            )}
        </Button>
    )
);

export default withStyles(styles)(ButtonsForm);
